import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ind-block-level-loader',
    templateUrl: 'ind-block-level-loader.html',
  styleUrls:['ind-block-level-loader.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndBlockLevelLoader {
}
